import { jobColors } from "../../../../../../ui/colors";

export const getStatusPalette = (status) => {
  const map = {
    "for-revision": "forRevision",
    for_revision: "forRevision",
    approved: "approved",
    scheduled: "scheduled",
    "inprogress": "inProgress",   
    in_progress: "inProgress",
    completed: "completed",
    support: "support",
    cancelled: "cancelled",
  };

  const key = map[status?.toLowerCase()] || "forRevision";
  return jobColors[key];
};
